import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { DeleteAccessRequest } from '../../types/access'
import api from '../../api'

const useUpdatePermissionsForUser = (userEmail: string) => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (deleteAccessRequest: DeleteAccessRequest) => {
			return api.accessManagement.deletePermissionsForUser(deleteAccessRequest)
		},
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ['allUserPermissions']
			})
			queryClient.invalidateQueries({
				queryKey: ['userPermissions', userEmail]
			})
		}
	})
}

export default useUpdatePermissionsForUser
